import { DataTableMeta } from '@otp/ui';
import { TFunction } from 'i18next';
import React from 'react';
import { Arrow } from '@otp/icons';

import { StoreModel, WttpTemplate } from 'src/graphql/generated/graphql';
import { RestaurantAddress } from '../../../../manage-restaurants/list/table/columns';

export const getTableConfig = (
  {
    stores,
    template,
    selectedRowIds,
  }: {
    stores: Array<
      Pick<StoreModel, 'id' | 'name' | 'postalCode' | 'city' | 'address1'> & {
        wttpTemplate?: Pick<WttpTemplate, 'id' | 'name'> | null;
      }
    >;
    template: Pick<WttpTemplate, 'id' | 'name'>;
    selectedRowIds: string[];
  },
  { t }: { t: TFunction },
) => [
  {
    name: 'name',
    label: t('manage-restaurants.store-name'),
    options: {
      sort: true,
      customBodyRender: (_: any, column: DataTableMeta) => {
        const rowData = (stores[column.rowIndex] || {}) as Partial<StoreModel>;
        return <RestaurantAddress restaurant={rowData} />;
      },
    },
  },
  {
    name: 'nationalStoreNumber',
    label: t('manage-restaurants.store-number'),
    options: {
      sort: false,
    },
  },
  {
    name: 'existingAssignment',
    label: t('wttp.template.store-assignment.existing-assignment'),
    options: {
      sort: false,
      customBodyRender: (_: any, column: DataTableMeta) => {
        const rowData = stores[column.rowIndex];
        return rowData?.wttpTemplate?.name;
      },
    },
  },
  {
    name: 'arrow',
    label: ' ',
    options: {
      sort: false,
      customBodyRender: (_: any, column: DataTableMeta) => {
        const rowData = stores[column.rowIndex];
        const storeId = rowData?.id;
        const showArrow = selectedRowIds.includes(storeId);

        return showArrow && <Arrow className="rotate-180" />;
      },
    },
  },
  {
    name: 'willBeAssigned',
    label: t('wttp.template.store-assignment.will-be-assigned'),
    options: {
      sort: false,
      customBodyRender: (_: any, column: DataTableMeta) => {
        const rowData = stores[column.rowIndex];
        const storeId = rowData?.id;
        return selectedRowIds.includes(storeId) ? template.name : '';
      },
    },
  },
];
